import apiClient from "./index";

/** 댓글 API */
// 댓글 내용 등록
export const saveCmnt = cmnt => {
    return apiClient.post(`/sys/cmnt/saveProc.json`, cmnt);
}
// 댓글 내용 목록 조회
export const findCmntList = cmnt => {
    return apiClient.post(`/sys/cmnt/findCmntList.json`, cmnt);
}
// 댓글 내용 수정
export const updateCmnt = cmnt => {
    return apiClient.post(`/sys/cmnt/updateProc.json`, cmnt);
}
// 댓글 내용 삭제
export const deleteCmnt = cmnt => {
    return apiClient.post(`/sys/cmnt/deleteProc.json`, cmnt);
}